module.exports = __webpack_public_path__ + "img/carousel_1.16b7f436.jpg";